<!-- <template>
  <div class="review-page">
    <h1>Recensioni degli Utenti</h1>
    <div v-if="reviews.length > 0">
      <div class="review-card" v-for="review in reviews" :key="review.Date">
        <h3>{{ review.name }}</h3>
        <p>{{ review.Text }}</p>
        <div class="star-rating">
          <span v-for="star in 5" :key="star" class="star" :class="{ active: review.Value >= star }">
            &#9733;
          </span>
        </div>
        <p>{{ review.Date }}</p>
      </div>
    </div>

    <div v-else>
      <p>Non ci sono ancora recensioni.</p>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import UrlsService from "@/helpers/UrlsService.js";
import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
import TimeService from "@/helpers/TimeService";

export default {
  data() {
    return {
      reviews: []
    };
  },
  async created() {
    await this.fetchReviews();
  },
  methods: {
    async fetchReviews() {
      let requestUrl = {
        url: UrlsService.getlastReview,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        Name: "innovation"
      };
      let requestObject = {
        type: "public",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: "Uploading Reviews",
        error: "Error uploading Reviews",
      };
      let options = {
        loadingType: "notification",
        timeout: TimeService.secondsToMillis(0),
      };
      APILoaderDecoratorService.setLoader(requestObject, messages, options)
        .then(responseSuccess => {
          let response = responseSuccess;
          console.log(response);

        })
        .catch(err => {
          this.message = "Error during the upload";
        });
    }
  }
};
</script>

<style scoped>
.review-page {
  padding: 20px;
  font-family: 'Roboto', sans-serif;
}

.review-card {
  background: white;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.star-rating .star {
  color: gray;
}

.star-rating .star.active {
  color: #ffcc00;
}
</style> -->

<template>
  <div class="review-page">
    <h1>User's Reviews</h1>
    <p class="review-description">
      Here you can read user reviews about our website. Discover what they think about our platform, the features offered, and how intuitive it is to use.
    </p>
    <div v-if="reviews.length > 0" class="reviews-container">
      <!-- Sposta la valutazione media qui, in alto -->
      <div class="average-rating">
        <h3>Average rating of all reviews: {{ calculateLocalAverageRating().toFixed(2) }} stars</h3>
      </div>
      <div class="review-card" v-for="(review, index) in reviews" :key="index">
        <div class="card">
          <div class="card-body">
            <h3 class="card-title">{{ review.name }}</h3>
            <p class="card-text">{{ review.Text }}</p>
            <div class="star-rating">
              <span v-for="star in 5" :key="star" class="star" :class="{ active: Number(review.Value) >= star }">
                &#9733;
              </span>
            </div>
            <p class="card-date">{{ review.Date }}</p>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="no-reviews">
      <p>Non ci sono ancora recensioni.</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import UrlsService from "@/helpers/UrlsService.js";

export default {
  data() {
    return {
      reviews: [],
      averageRating: 0
    };
  },
  async created() {
    await this.fetchReviews();
    await this.fetchAverageRating();
  },
  methods: {
    async fetchReviews() {
      const requestUrl = UrlsService.getAllReviews;

      try {
        const response = await axios.get(requestUrl);
        console.log("Response received:", response);

        if (response && response.data) {
          this.reviews = response.data;
        } else {
          console.error("No data found in response:", response);
        }
      } catch (err) {
        console.error("Error during the fetch", err);
      }
    },
    async fetchAverageRating() {
      const requestUrl = UrlsService.getAverageRating;
      try {
        const response = await axios.get(requestUrl);
        this.averageRating = response.data || 0;
      } catch (err) {
        console.error("Error fetching average rating", err);
        this.averageRating = 0;
      }
    },
    calculateLocalAverageRating() {
      if (this.reviews.length === 0) return 0;

      const total = this.reviews.reduce((sum, review) => {
        return sum + Number(review.Value);
      }, 0);

      return total / this.reviews.length;
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap');

html, body {
  height: auto;
  margin: 0;
  padding: 0;
  min-height: 100%;
}

.review-page {
  padding: 20px;
  text-align: center;
  background: linear-gradient(to right, #e3f2fd, #f1f8e9);
  font-family: 'Roboto', sans-serif;
}

.reviews-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.review-card {
  margin-bottom: 20px;
  width: 90%;
  max-width: 600px;
}

.card {
  border: 1px solid #ddd;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 20px;
  background-color: #fff;
  transition: transform 0.2s, box-shadow 0.2s;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.2);
}

.card-body {
  padding: 15px;
}

.card-title {
  font-size: 1.5em;
  margin-bottom: 10px;
  font-weight: bold;
  color: #333;
}

.card-text {
  font-size: 1.1em;
  margin-bottom: 15px;
  color: #555;
}

.card-date {
  font-size: 0.9em;
  color: #888;
}

.star-rating {
  display: inline-block;
  margin-bottom: 10px;
}

.star {
  font-size: 25px;
  color: #d3d3d3;
  cursor: pointer;
  transition: color 0.3s;
}

.star.active {
  color: #FFD700;
}

.no-reviews {
  font-size: 1.2em;
  color: #777;
}

.average-rating {
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: 1.5em;
  color: #333;
}

</style>
